/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardText, CardBody, Button } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';

const RevenueTable = ({ dataToShowForDatesSelected,
  tableHeaderData }) => {
  const { t } = useTranslation('common');
  return (   
    <Col xs="12">
             <Card className="pb-3 show-categ-daily-sales">              
                 {dataToShowForDatesSelected.length ? (
             <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }}
              data={dataToShowForDatesSelected} />
             ): <div className="no-data">No data to display</div>}
             </Card>
         </Col>    
  )
}

RevenueTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  tableHeaderData: PropTypes.array.isRequired,
};

export default RevenueTable;

